<div class="page">
  @if (!loading()) {
    @if (gallery?.teaser?.uuid) {
      <div class="asset-container">
        <img
          [src]="gallery | galleryTeaserUrl: 160"
          [style.object-position]="gallery.teaser.uuid === gallery.cover?.uuid ? gallery.cover?.position : undefined"
          alt=""
          class="asset"
        />
        <div class="icon">
          <app-svg src="/assets/icons/cross-circle.svg"></app-svg>
        </div>
      </div>
    }
    <h1>Unsubscribed!</h1>
    <p>You’ve now unsubscribed and wont get any new updates for this gallery going forward.</p>
    <a
      appButton
      name="view-gallery"
      location="unsubscribe-from-gallery-page"
      color="primary"
      size="3"
      shape="round"
      height="4"
      spacing="5"
      [routerLink]="'/gallery/' + gallery.id + '/feedback'"
      [center]="true"
      >View Gallery</a
    >
  }
</div>
